import React from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import {  MdOutlineSmartphone } from "react-icons/md";
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import { GrNetwork } from "react-icons/gr";
import { tokens } from "../../theme";
import { useTheme } from "@mui/material";

const menuItems = [
  {
    title: "Inicio",
    path: "/home",
    icon: <FaHome size={40} />,
    description: "Overview of your activities",
  },
  {
    title: "Test Vocacional",
    path: "/vocacional",
    icon: <LibraryBooksIcon size={40} />,
    description: `Averigua qué estudios son los más adecuados para ti 
       respondiendo a las preguntas de este test de orientación vocaional`,
  },
  {
    title: "Telefonía Móvil",
    path: "/telefoniaMovil",
    icon: <MdOutlineSmartphone size={40} />,
    description: `Tasa por Supervisión de Telefonía Fija, Cuadro de Supervisión. 
      Análisis y Cálculos sobre el reporte de ingresos`,
  },
  {
    title: "Tráfico Entrante Internacional",
    path: "/traficoEntrante",
    icon: <GrNetwork size={40} />,
    description: `Liquidación Tráfico Internacional Entrante, Cuadro de Supervisión. 
      Análisis y Cálculos sobre el reporte de ingresos`,
  },
];

const Home = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m={4}>
      <Grid container spacing={4}>
        {menuItems.map((item) => (
          <Grid item xs={12} sm={6} key={item.path}>
            <Card sx={{ display: "flex", minHeight: "150px", boxShadow: 3 }}>
              <Box
                sx={{
                  width: "8px",
                  backgroundColor: colors.indigoAccent[500],
                  borderRadius: "4px 0 0 4px",
                }}
              />
              <CardActionArea
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                onClick={() => navigate(item.path)}
              >
                <Box
                  sx={{
                    padding: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {item.icon}
                </Box>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h5" component="div">
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {item.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Home;
